import { StepProps, Steps } from 'antd';
import { MasterSubCategory } from 'domain/entities/MasterEntity';
import { MyPageUserInfo } from 'domain/entities/UserEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, showConfirm, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { RegistrationStepOne } from './components/RegistrationStepOne';
import { RegistrationStepTwo } from './components/RegistrationStepTwo';

const items: StepProps[] = Array.from(Array(2).keys()).map(() => {
    return {};
});

const MASTER_GROUP_CODES = [
    MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION,
];

export const NUMBER_MULTIPLE_DEPOSIT = 100000;

const CU0050101Page = (props: AppProps) => {
    const dispatch = useAppDispatch();
    const [current, setCurrent] = useState(0);
    const [masterData, setMasterData] = React.useState<any>();
    const [data, setData] = React.useState<MyPageUserInfo>();
    const { masterUseCase, userUseCase } = props;
    const [searchParams] = useSearchParams();
    const step = searchParams.get('step') || '';
    const [isChange, setIsChange] = useState<boolean>(false);
    const [isInit, setIsInit] = useState(true);

    useEffect(() => {
        (async () => {
            if (step) {
                setCurrent(Number(step) - 1);
            }
            await Promise.all([initiateDefaultData(Number(step) - 1), initiateOptions()]);
        })();
    }, []);

    const initiateOptions = async () => {
        try {
            dispatch(startFetching());
            const options = await masterUseCase.getMasterSubCategoryGroupList({
                categoryCodes: MASTER_GROUP_CODES,
            });
            const masterDataInit: any = {
                ...options,
            };
            masterDataInit[MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION
            ]?.map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION
            ]
                ?.filter((item: MasterSubCategory) => item.code !== '99')
                .map((item: MasterSubCategory) => {
                    return {
                        label: item.codeName,
                        value: item.code,
                    };
                });
            masterDataInit[MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION] =
                masterDataInit[MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION]
                    ?.filter((item: MasterSubCategory) => item.code !== '99')
                    .map((item: MasterSubCategory) => {
                        return {
                            label: item.codeName,
                            value: item.code,
                        };
                    });
            masterDataInit[MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION] = masterDataInit[
                MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION
            ].map((item: MasterSubCategory) => {
                return {
                    label: item.codeName,
                    value: item.code,
                };
            });
            setMasterData(masterDataInit);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const initiateDefaultData = async (currentStep: number) => {
        try {
            dispatch(startFetching());
            let response = null;
            response = await userUseCase.getDefaultInfo();

            if (response && response.result) {
                const mappingData = {...response.result};
                setData(mappingData);
            }
            setIsInit(false);
        } catch (error: any) {
            openErrorNoti();
        } finally {

            dispatch(completeFetching());
        }
    };

    useEffect(() => {
        if (!isInit) {
            initiateDefaultData(current);
        }
    }, [current]);

    const scrollTop = () => {
        document.getElementById('top-form')?.scrollIntoView({ behavior: 'smooth' });
    };

    const { Step } = Steps;

    const render = (step: number) => {
        switch (step) {
            case 1:
                return (
                    <RegistrationStepTwo
                        {...props}
                        setIsChange={setIsChange}
                        data={data}
                        masterData={masterData}
                        current={current}
                        index={2}
                        next={next}
                        prev={prev}
                        scrollTop={scrollTop}
                    />
                );
            default:
                return (
                    <RegistrationStepOne
                        {...props}
                        setIsChange={setIsChange}
                        data={data}
                        masterData={masterData}
                        current={current}
                        index={1}
                        next={next}
                        prev={prev}
                        scrollTop={scrollTop}
                    />
                );
        }
    };

    const next = () => {
        setIsChange(false);
        setCurrent(current + 1);
    };

    const prev = () => {
        if (isChange) {
            const confirmProps = commonHelpers.getConfirmProps('P001', {
                onOk: () => {
                    setCurrent(current - 1);
                },
            });
            dispatch(showConfirm(confirmProps));
        } else {
            setCurrent(current - 1);
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-005-01-container"
        >
            <PageTitle title="重要情報の登録" />
            <section
                style={{
                    padding: '0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="purchase-form-container w-full">
                    <Steps current={current} responsive className="w-1/4">
                        {items.map((item, index) => (
                            <Step key={index} status={index === current ? 'process' : 'wait'} />
                        ))}
                    </Steps>
                    <div className="section-wrapper">{render(current)}</div>
                </div>
            </section>
        </div>
    );
};

export default CU0050101Page;
